export default "__VITE_ASSET__d25fc949__"